import { PollRecord } from '../../../models/Poll';

interface OptionImgProps {
    poll: PollRecord;
    option: 1 | 2;
}

const OptionImg = (props: OptionImgProps): JSX.Element => {
    return (
        <>
            {/* HP3 */}
            {props.poll.options[props.option - 1].image && (
                <img
                    className='poll-option-img'
                    src={
                        process.env.REACT_APP_IMAGES_URL +
                        '/' +
                        props.poll.options[props.option - 1].image
                    }
                    alt={props.poll.options[props.option - 1].text}
                />
            )}
        </>
    );
};

export default OptionImg;
